/* src/app/components/billing/ledger/view-ledger/view-ledger.component.css */
/*# sourceMappingURL=view-ledger.component-RKT4ZGJU.css.map */
